import { QuestionOptionV3 } from '../models/dynamic-form-v3.models';
import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class ToggleQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.TOGGLE;
  options: QuestionOptionV3[];

  constructor(options: any = {}) {
    super(options);
    this.options = options['options'] || [];
  }
}
